import { Input } from '@/components/ui/input';

interface TextInputFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  maxCharacters?: number;
  required?: boolean;
  disabled?: boolean;
  forcedValue?: string | null;
  error?: string;
}

export function TextInputField({
  label,
  value,
  onChange,
  maxCharacters,
  required = false,
  disabled = false,
  forcedValue,
  error,
}: TextInputFieldProps) {
  const isForced = forcedValue !== null && forcedValue !== undefined;
  const displayValue = isForced ? forcedValue : value;

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-foreground">
        {label}
        {required && <span className="ml-0.5 text-red-500">*</span>}
      </label>
      <Input
        value={displayValue}
        onChange={(e) => {
          if (!isForced) onChange(e.target.value);
        }}
        maxLength={maxCharacters}
        disabled={disabled || isForced}
        className={error ? 'border-red-500' : ''}
        aria-invalid={!!error}
      />
      {maxCharacters && (
        <span className="text-xs text-muted-foreground text-right">
          {(displayValue || '').length}/{maxCharacters}
        </span>
      )}
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
}
